import { useEffect } from "react";
import Navbar from "./Navbar.component";
import EventBus from "../common/EventBus";
import { Outlet } from "react-router-dom";
import { useLogout } from "../hooks/useLogout";
import useVerifyJwt from "../hooks/useVerifyJwt";

function Applayout() {
  const { logout } = useLogout();
  const { isExpire } = useVerifyJwt();

  useEffect(() => {
    EventBus.on("logout", () => {
      logout();
    });

    if (isExpire) {
      logout();
    }

    return () => {
      EventBus.remove("logout");
    };
  }, [logout, isExpire]);

  return (
    <div>
      <Navbar logOut={logout} />
      <main className="app-content container-md">
        <Outlet />
      </main>
    </div>
  );
}

export default Applayout;
